// extracted by mini-css-extract-plugin
module.exports = {"block":"resolve-problems_block__20PwA"};